import { ModuleWithProviders } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { FirstRegistrationStepComponent } from './first-registration-step.component';
import { RulesComponent } from '../../../components/shared/components/rules/rules.component';

const routes: Routes = [
  {
    path: '',
    component: FirstRegistrationStepComponent,
    children: [{ path: 'rules', component: RulesComponent }],
  },
];

export const routing: ModuleWithProviders<any> = RouterModule.forChild(routes);
